module.exports = __webpack_public_path__ + "img/f9.d046f294.jpg";